import { IData } from "./types";

export const initData: IData = {
  isEnabled: false,
  amountBelow: "0.00",
  amountTopUp: "0.00",
  authCode: "",
};
